import { render, staticRenderFns } from "./PrivatePlotDetail.vue?vue&type=template&id=9923ec2a&"
import script from "./PrivatePlotDetail.vue?vue&type=script&lang=js&"
export * from "./PrivatePlotDetail.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePlotDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports